// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"130":"98500baca90ddc0b","362":"d6ed33442cd8dc47","547":"805703ddf864dc29","821":"b2aa8d7cd790731b"}[chunkId] + ".js";
};